import { PageType } from '@app-types/PageType'
import LoadingSpinner from '@components/shared/Loading/Loading'
import useFontSizes from '@hooks/useFontSizes'
import type { FC } from 'react'
import DuaPart from './DuaPart'

export type DuaPartType = {
  arab: string
  meal: string
  id?: number
  latin?: string
  no?: number
  repeat?: number
  note?: string
  afterNote?: string
}

type DuaPageComponentProps = {
  data: DuaPartType[]
  type: PageType
  page: number
  noBookmark?: boolean
}

const DuaPageComponent: FC<DuaPageComponentProps> = ({
  data,
  type,
  page,
  noBookmark,
}) => {
  const { duaArabFontSize, duaMealFontSize } = useFontSizes()

  if (!data) {
    return <LoadingSpinner />
  }

  return (
    <>
      <style>
        {`
        .dua-arabic {
          font-size: ${duaArabFontSize}px;
          direction: rtl;
        }

        @keyframes fadeInSlide {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-dua-part {
          animation: fadeInSlide 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        @media (min-width: 600px) {
          .dua-arabic {
            text-align: justify;
          }
        }
        .dua-meal {
          font-size: ${duaMealFontSize}px;
          direction: ltr;
        }

        .ayah-id.text-emerald-800 .dua-meal,
        .ayah-id.text-emerald-800 .dua-arabic {
          color: inherit !important;
        }
      `}
      </style>
      <div className="space-y-3">
        {data.map((part: DuaPartType, key: number) => {
          const isLastItem = key === data.length - 1
          return (
            <div
              key={key}
              className="animate-dua-part opacity-0"
              style={{ animationDelay: `${key * 75}ms` }}
            >
              <DuaPart {...{ isLastItem, part, type, page, partKey: key, noBookmark }} />
            </div>
          )
        })}
      </div>
    </>
  )
}

export default DuaPageComponent
